'use client';

import { AmenityCGType } from '@/types/graphql/root';
import Image from 'next/image';

export default function PoiDetailAmenities({ amenities }: { amenities: AmenityCGType[] }) {
  if (amenities.length === 0) return null;

  return (
    <>
      <div id='poi-detail-amenities'>
        <p className='text-gray-800 px-20pxr pt-24pxr heading-16-b'>편의시설</p>
        <div className='grid grid-cols-2 px-20pxr pt-24pxr pb-32pxr'>
          {amenities.map((amenity, idx) => (
            <div key={idx} className='flex flex-row items-center justify-start mb-16pxr'>
              <Image src={amenity.imageUrl ?? ''} alt='amenity' width={24} height={24} className='w-24pxr h-24pxr' />
              <p className='text-gray-700 ml-12pxr body-16-r'>{amenity.name}</p>
            </div>
          ))}
        </div>
      </div>
      <div className='w-full bg-gray-100 h-12pxr'></div>
    </>
  );
}
